import { useRouteItems } from '../../../hooks/route'
import { useContextState } from '../../../hooks/theme'
import { getLocalStorage } from '../../../utils/crud/crypt'
import { Roles } from '../../../utils/enums'
import { canAccess } from '../../../utils/validate/canaccess'
import { Items, User } from './types'
const onlyAdmin = [Roles.AGENT, Roles.STORE, Roles.SUPERVISOR, Roles.PARTNER, Roles.SUPPORT, Roles.AUDIT, Roles.GERENT]
const allRoles = [Roles.ADMIN, Roles.SUPERVISOR, Roles.PARTNER, Roles.SUPPORT, Roles.AUDIT, Roles.GERENT, Roles.STORE, Roles.AGENT]
export const useListItem = (): Items[] => {
  const routeItems = useRouteItems();
  const { state } = useContextState()
  const servicePermission = [Roles.ADMIN]
  const localStorage: User = getLocalStorage()
  const existedCompany = !!state?.company?.id

  if (state.isManagerOfDeparment && state.role) { servicePermission.push(state.role) }

  const serviceFiltered = allRoles.filter(role => !servicePermission.includes(role))

  return [
    {
      label: routeItems.dashboard.main.label,
      icon: 'bar-chart',
      path: routeItems.dashboard.main.paths,
      base: routeItems.dashboard.main.base,
      access: allRoles,
    },
    {
      label: routeItems.reports.main.label,
      icon: 'table',
      path: '',
      base: routeItems.reports.main.base,
      access: allRoles,
      children: [
        {
          label: routeItems.reports.programmed.label,
          icon: 'horizontal-line',
          path: routeItems.reports.programmed.paths,
          base: routeItems.reports.programmed.base,
        },
        {
          label: routeItems.reports.programation.label,
          icon: 'horizontal-line',
          path: routeItems.reports.programation.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.reports.programation.base,
        },
        {
          label: routeItems.reports['progress-questionnaire'].label,
          icon: 'horizontal-line',
          path: routeItems.reports['progress-questionnaire'].paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.reports['progress-questionnaire'].base,
        },
      ],
    },
    {
      label: routeItems['organization-chart'].main.label,
      icon: 'tree',
      path: '',
      access: servicePermission,
      base: routeItems['organization-chart'].main.base,
      children: [
        {
          label: routeItems['organization-chart'].area.label,
          icon: 'horizontal-line',
          path: routeItems['organization-chart'].area.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems['organization-chart'].area.base,
        },
        {
          label: routeItems['organization-chart'].departments.label,
          icon: 'horizontal-line',
          path: routeItems['organization-chart'].departments.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems['organization-chart'].departments.base,
        },
        {
          label: routeItems['organization-chart']['area-department'].label,
          icon: 'horizontal-line',
          path: routeItems['organization-chart']['area-department'].paths,
          notAllowedRoles: serviceFiltered,
          base: routeItems['organization-chart']['area-department'].base,
        },
      ],
    },
    {
      label: routeItems.user.main.label,
      icon: 'user',
      path: '',
      access: allRoles,
      base: routeItems.user.main.base,
      children: [
        {
          label: routeItems.user.register.label,
          icon: 'horizontal-line',
          path: routeItems.user.register.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.user.register.base,
        },
        {
          label: routeItems.user['user-type'].label,
          icon: 'horizontal-line',
          path: routeItems.user['user-type'].paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.user['user-type'].base,
        },
        {
          label: routeItems.user['group-gestion'].label,
          icon: 'horizontal-line',
          path: routeItems.user['group-gestion'].paths,
          notAllowedRoles: [],
          base: routeItems.user['group-gestion'].base,
        },
      ],
    },
    {
      label: routeItems.unit.main.label,
      icon: 'store',
      path: '',
      base: routeItems.unit.main.base,
      access: [Roles.ADMIN, Roles.SUPPORT, Roles.AUDIT],
      children: [
        {
          label: routeItems.unit.store.label,
          icon: 'horizontal-line',
          path: routeItems.unit.store.paths,
          base: routeItems.unit.store.base,
        },
        {
          label: routeItems.unit.division.label,
          icon: 'horizontal-line',
          path: routeItems.unit.division.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.unit.division.base,
        },
        {
          label: routeItems.unit.zone.label,
          icon: 'horizontal-line',
          path: routeItems.unit.zone.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.unit.zone.base,
        },
      ],
    },
    {
      label: routeItems.questionnarie.main.label,
      icon: 'paper',
      path: routeItems.questionnarie.main.paths,
      access: allRoles,
      extraPaths: ['questionnarie/'],
      base: routeItems.questionnarie.main.base,
    },
    {
      label: routeItems.calendar.main.label,
      icon: 'calendar',
      path: routeItems.calendar.main.paths,
      access: allRoles,
      extraPaths: ['calendar/'],
      base: routeItems.calendar.main.base,
    },
    {
      label: routeItems['schedule-user'].main.label,
      icon: 'schedule-user',
      path: routeItems['schedule-user'].main.paths,
      extraPaths: ['schedule-user/'],
      base: routeItems['schedule-user'].main.base,
      access: allRoles,
    },
    {
      label: routeItems['action-plan'].main.label,
      icon: 'action-plan',
      path: '',
      base: routeItems['action-plan'].main.base,
      access: [Roles.ADMIN, Roles.SUPERVISOR, Roles.SUPPORT, Roles.AGENT, Roles.STORE, Roles.PARTNER, Roles.GERENT, Roles.AUDIT],
      extraPaths: ['action-plan/create'],
      children: [
        {
          label: routeItems['action-plan'].created.label,
          icon: 'horizontal-line',
          path: routeItems['action-plan'].created.paths,
          base: routeItems['action-plan'].created.base,
        },
        {
          label: routeItems['action-plan']['to-generate'].label,
          icon: 'horizontal-line',
          path: routeItems['action-plan']['to-generate'].paths,
          base: routeItems['action-plan']['to-generate'].base,
        },
      ],
    },
    {
      label: routeItems['report-folio'].main.label,
      icon: 'source',
      path: '',
      base: routeItems['report-folio'].main.base,
      access: [Roles.ADMIN, Roles.SUPERVISOR, Roles.AGENT, Roles.STORE, Roles.PARTNER, Roles.SUPPORT, Roles.AUDIT, Roles.GERENT],
      children: [
        {
          label: routeItems['report-folio'].dashboard.label,
          icon: 'horizontal-line',
          path: routeItems['report-folio'].dashboard.paths,
          base: routeItems['report-folio'].dashboard.base,
        },
        {
          label: routeItems['report-folio'].settings.label,
          icon: 'horizontal-line',
          path: routeItems['report-folio'].settings.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems['report-folio'].settings.base,
        },
        {
          label: 'Centro de notificaciones',
          icon: 'horizontal-line',
          path: 'dashboard/report-folio/notification',
          notAllowedRoles: onlyAdmin,
          base: 'notification',
        },
        {
          label: routeItems['report-folio']['catalog'].label,
          icon: 'horizontal-line',
          path: routeItems['report-folio']['catalog'].paths,
          notAllowedRoles: serviceFiltered,
          base: routeItems['report-folio']['catalog'].base,
        },
        {
          label: routeItems.service['time-config'].label,
          icon: 'horizontal-line',
          path: routeItems.service['time-config'].paths,
          notAllowedRoles: serviceFiltered,
          base: routeItems.service['time-config'].base,
        },
      ],
    },
    {
      label: routeItems.filesManager.main.label,
      icon: 'paper',
      path: routeItems.filesManager.main.paths,
      base: routeItems.filesManager.main.base,
      extraPaths: ['filesManager/'],
      access: allRoles,
      //permissions: (localStorage.accessPermissionsActivities?.access_web == 1) || localStorage.role == Roles.ADMIN
    },
    {
      label: routeItems.logbook.main.label,
      icon: 'calendar',
      path: routeItems.logbook.main.paths,
      base: routeItems.logbook.main.base,
      access: allRoles,
      permissions: (localStorage.accessPermissionsActivities?.access_web == 1) || localStorage.role == Roles.ADMIN
    },
    {
      label: routeItems.setting.main.label,
      icon: 'setting',
      path: '',
      access: [Roles.ADMIN],
      base: routeItems.setting.main.base,
      children: [
        {
          label: routeItems.setting['admin-users'].label,
          icon: 'horizontal-line',
          path: routeItems.setting['admin-users'].paths,
          notAllowedRoles: existedCompany ? [Roles.ADMIN] : onlyAdmin,
          base: routeItems.setting['admin-users'].base,
        },
        {
          label: routeItems.setting['option-group'].label,
          icon: 'horizontal-line',
          path: routeItems.setting['option-group'].paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.setting['option-group'].base,
        },
        {
          label: routeItems.setting.companies.label,
          icon: 'horizontal-line',
          path: routeItems.setting.companies.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.setting.companies.base,
        },
        {
          label: routeItems.setting.dropList.label,
          icon: 'horizontal-line',
          path: routeItems.setting.dropList.paths,
          notAllowedRoles: onlyAdmin,
          base: routeItems.setting.dropList.base,
        },
      ],
    },
    {
      label: routeItems.localization.main.label,
      icon: 'map',
      path: routeItems.localization.main.paths,
      base: routeItems.localization.main.base,
      access: [Roles.ADMIN, Roles.SUPERVISOR, Roles.AGENT, Roles.GERENT, Roles.STORE],
    },
  ]?.filter((item) => canAccess(item.access ?? []) && (item.permissions === undefined || item.permissions))
}
